import React from 'react'
import './about.css'

const About = () => {
  return (
    <section className='about'>
      <div className='about-wrapper'>
        <p className='about-content'>
        Welcome to Brand Hotel Dodoma. Conveniently located in Kisasa along Kisasa road  a few minutes from the city center. Brand hotel is an ultimate gateway for your accomodation, restaurant & lounge and formally for meetings and events services. We take pride in offering exceptional hospitality service delivery and contentment of your travel, official and vacation demands.
        </p>
        <p className='about-content'>
        Our  accommodation services varying from Standard rooms to executive suites,  exceptionally furnished to ensure your stay is pleasant, appealing and inviting as preferred. Our rooms and suites are  deliberately intended to make you feel at home with each hospitality detail paid attention to.  Furnished with the best modern amenities, they surely offer you privacy,  tranquility, comfort and ambiance at a go.
        </p>
        <p className='about-content'>
        Delight your taste buds in tasteful  breakfast and other meals of the day at our restaurant with local and international delicacies.  Make your special order from a well-considered menu with  array of splendid cuisines.  As you prefer savor your meals in the restaurant or in the garden while relishing amazing views. Additionally, our state-of-art bar  stocked with drinks from  local and international brands makes  your stay or visit complete and as desired. 
        </p>
      </div>
    </section>
  )
}

export default About